import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, refundMethods, Text } from '@reveni-io/reveni-ui'

import { subscriptionPlans } from '@/common/constants'
import DisableInstantRefundMethodsAlert from '@/configuration/pages/ConfigurationPage/RefundsConfiguration/DisableInstantRefundMethodsAlert/DisableInstantRefundMethodsAlert'

import { instantAllowedTypes } from './constants'
import * as Styles from './styles'

const AvailabilitySelector = ({
  instantAllowed,
  onChange,
  refundMethodType,
  subscriptionPlan,
  originalInstantAllowed,
  allowInstantTransactions,
  disabled,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getValue = () => {
    if (subscriptionPlan === subscriptionPlans.basic) {
      return instantAllowedTypes.instantNotAllowed
    }

    if (refundMethodType !== refundMethods.bankTransfer) {
      return instantAllowed ? instantAllowedTypes.instantAllowed : instantAllowedTypes.instantNotAllowed
    }

    return instantAllowedTypes.instantAllowed
  }

  const handleChange = e => {
    onChange(e.target.value === instantAllowedTypes.instantAllowed)
  }

  const getInstantAllowedLabel = () => {
    if (refundMethodType === refundMethods.bankTransfer) {
      return t('Reembolso instantáneo')
    }

    return t('Reembolso instantáneo y no instantáneo')
  }

  const getOptions = () => {
    const options = [{ label: t('Reembolso no instantáneo'), value: instantAllowedTypes.instantNotAllowed }]

    if (allowInstantTransactions) {
      options.unshift({
        label: getInstantAllowedLabel(),
        value: instantAllowedTypes.instantAllowed,
      })
    }

    return options
  }

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Disponibilidad')}</Text>
      <Text type="bodyMRegular">
        {t('Este método estará disponible en el portal para los siguientes modos de reembolso')}
      </Text>
      <div>
        <ComboBox
          fullWidth
          label={t('Disponibilidad para')}
          value={getValue()}
          handleChange={handleChange}
          menuItems={getOptions()}
          backgroundColor={theme.colors.background.primary}
          disabled={
            disabled ||
            refundMethodType === refundMethods.bankTransfer ||
            subscriptionPlan === subscriptionPlans.basic ||
            originalInstantAllowed
          }
        />
        {originalInstantAllowed && <DisableInstantRefundMethodsAlert />}
      </div>
    </Styles.Container>
  )
}

export default AvailabilitySelector
